import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0%;\n\n  width: 100%;\n  height: 100%;\n\n  background-color: var(--train-color);\n\n  transform-origin: 0% 0%;\n\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  width: 100%;\n  height: 4px;\n  overflow: hidden;\n\n  background-color: var(--track-color);\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 100px;\n  align-self: ", ";\n  padding-block-start: var(", ");\n  text-align: start;\n\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n\n  max-width: calc(var(--size) - var(--stroke-width) * 2 - 1ch);\n  overflow: hidden;\n\n  ", "\n  text-overflow: ellipsis;\n\n  transform: translate(-50%, -50%);\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  fill: none;\n\n  stroke: var(--track-color);\n  stroke-width: var(--stroke-width);\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  transform-origin: 50% 50%;\n\n  fill: none;\n\n  stroke: var(--train-color);\n  stroke-width: calc(var(--stroke-width));\n\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      ", " 1.5s cubic-bezier(0.4, 0, 0.3, 1) infinite\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: var(--size);\n  height: var(--size);\n\n  transform-origin: 50% 50%;\n\n  animation: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  --size: ", "px;\n  --stroke-width: ", "px;\n  --train-color: var(\n    ", "\n  );\n  --track-color: var(\n    ", "\n  );\n  --progress: ", ";\n\n  position: relative;\n  align-self: center;\n\n  display: inline-block;\n\n  width: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  flex-direction: column;\n  position: relative;\n  color: var(\n    ", "\n  );\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  transform: scaleX(var(--progress));\n\n  transition: transform ease-in-out 0.1s;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 1s\n    cubic-bezier(0.85, 0, 1, 1) infinite;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(0%) scaleX(0.0);\n  }\n  50% {\n    transform: translateX(20%) scaleX(0.5);\n\n    animation-timing-function: cubic-bezier(0,0,0,1);\n  }\n  100% {\n    transform: translateX(100%) scaleX(0.5);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  stroke-dasharray: calc(var(--progress) * ", "),\n    ", ";\n\n  transform: rotate(-90deg);\n\n  transition: stroke-dasharray 0.1s var(", ");\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 1.5s\n    cubic-bezier(0.3, 0.95, 0.65, 0.9) infinite both;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n      stroke-dasharray: ", ";\n      stroke-dashoffset: ", ";\n\n      animation-timing-function: ease-in;\n  }\n  20% {\n      stroke-dasharray: ", ";\n      stroke-dashoffset: ", ";\n  }\n  100% {\n      stroke-dasharray: ", ";\n      stroke-dashoffset: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(-90deg)\n  }\n  to {\n    transform: rotate(270deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { keyframes, css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
/** Circumfence in pixels based on --size of the circle */

var circumfence = "calc(".concat(Math.PI, " * (var(--size) - var(--stroke-width)))");
/** Convert degrees of an arc to dash lengths in pixels based on --size of the circle */

var dashLengthFromAngle = function dashLengthFromAngle(deg) {
  return "calc(".concat(deg, " / 360 * ").concat(circumfence, ")");
};
/** Layer one of the continuous spinning animation - pure rotation */


var continuousSpinningKeyframes = keyframes(_templateObject());
/** Layer two of the continuous spinning animation - SVG strokes */

var continuousCircularLoadingKeyframes = keyframes(_templateObject2(), [0, 360].map(dashLengthFromAngle).join(','), dashLengthFromAngle(0), [200, 360].map(dashLengthFromAngle).join(','), dashLengthFromAngle(-40), [200, 360].map(dashLengthFromAngle).join(','), dashLengthFromAngle(-360));
var continuousCircularLoadingAnimation = css(_templateObject3(), continuousCircularLoadingKeyframes); // Handle determinate percentage values (as opposed to the continual spinner)

var circularPercentValue = css(_templateObject4(), circumfence, dashLengthFromAngle(360), function (props) {
  return props.theme.easing;
});
/** Continuous horizontal bar animation */

var continuousHorizontalLoadingKeyframes = keyframes(_templateObject5());
var continuousHorizontalLoadingAnimation = css(_templateObject6(), continuousHorizontalLoadingKeyframes);
/** Handle determinate percentage values (as opposed to the continual spinner) */

var horizontalPercentValue = css(_templateObject7());
export var circularLoaderSizes = {
  continuous: {
    small: {
      diameter: 24,
      stroke: 2
    },
    large: {
      diameter: 48,
      stroke: 3
    }
  },
  determinate: {
    small: {
      diameter: 48,
      stroke: 3
    },
    large: {
      diameter: 96,
      stroke: 4
    }
  }
};
export var StyledRoot = styled.div(_templateObject8(), function (props) {
  return props.variant === 'circular' ? 'inline-flex' : 'flex';
}, function (props) {
  return props.inverted ? props.theme.colors.ui.inverted : props.theme.colors.ui.highlight.secondary;
}, injectSpacing('margin'));
export var StyledLoaderContainer = styled.div(_templateObject9(), function (props) {
  return circularLoaderSizes[props.progressType][props.size].diameter;
}, function (props) {
  return circularLoaderSizes[props.progressType][props.size].stroke;
}, function (props) {
  return props.monochrome ? props.inverted ? props.theme.colors.ui.inverted : props.theme.colors.ui.highlight.secondary : props.theme.colors.ui.highlight.primary;
}, function (props) {
  return props.inverted ? props.theme.colors.ui.secondary : props.theme.colors.ui.divider;
}, function (props) {
  return props.progress;
}, function (props) {
  return props.variant === 'linear' && ' 100%';
}); // Circular loader styles

export var StyledCircularLoader = styled.svg(_templateObject10(), function (props) {
  return props.progressType === 'continuous' && css(_templateObject11(), continuousSpinningKeyframes);
});
export var StyledCircularTrain = styled.circle(_templateObject12(), function (props) {
  return props.progressType === 'continuous' ? continuousCircularLoadingAnimation : circularPercentValue;
});
export var StyledCircularTrack = styled.circle(_templateObject13());
export var StyledValue = styled.div(_templateObject14(), function (props) {
  return injectTypography(props, props.size === 'large' ? 'copy1' : 'copy2');
});
export var StyledLabel = styled.div(_templateObject15(), function (props) {
  return props.variant === 'circular' ? 'center' : 'flex-start';
}, function (props) {
  return props.theme.responsive.spacing.xs;
}, function (props) {
  return injectTypography(props, 'copy2');
}); // Horizontal loader styles

export var StyledProgressBar = styled.div(_templateObject16());
export var StyledProgressBarTrain = styled.div(_templateObject17(), function (props) {
  return props.progressType === 'continuous' ? continuousHorizontalLoadingAnimation : horizontalPercentValue;
});